export const SET_WAITER_CALLS_WAITERS = 'SET_WAITER_CALLS_WAITERS'
export const SET_WAITER_CALLS_NOTIFICATIONS = 'SET_WAITER_CALLS_NOTIFICATIONS'
